import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import type { FormSubmitHandler, InjectedFormProps } from 'redux-form';
import { Form, Field, reduxForm } from 'redux-form';

import { USER_EMAIL_LOGIN } from 'af-constants/reduxForms';
import CLIENT from 'af-constants/routes/client';

import Input from 'af-fields/Input';

import SubmitButton from 'af-components/SubmitButton';

import type { UserEmailCredentials } from '../formModel';
import { emailValidate } from './validations';

interface OwnProps {
	orgAlias: string;
	onSubmit: FormSubmitHandler;
}

type Props = OwnProps & InjectedFormProps<UserEmailCredentials, OwnProps>;

class EmailForm extends React.PureComponent<Props> {
	render() {
		const { onSubmit, orgAlias, submitting, handleSubmit } = this.props;

		return (
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Row>
					<Col sm={24}>
						<Field
							component={Input}
							id="email"
							label="Email"
							name="email"
							type="text"
						/>
					</Col>
				</Row>
				<Row>
					<Col sm={24}>
						<Field
							component={Input}
							id="password"
							label="Password"
							name="password"
							type="password"
						/>
					</Col>
					<Link
						className="additional-input-element"
						tabIndex={-1}
						to={CLIENT.AUTH.PASS_FORGOTTEN(orgAlias)}
					>
						Forgot Password?
					</Link>
				</Row>
				<Row className="row--padded">
					<Col sm={24}>
						<SubmitButton
							fullWidth={true}
							label="Log in"
							reduxFormSubmitting={submitting}
						/>
					</Col>
				</Row>
			</Form>
		);
	}
}

export default reduxForm<UserEmailCredentials, OwnProps>({ form: USER_EMAIL_LOGIN, validate: emailValidate })(EmailForm);
